import * as React from 'react';
import Tab from '@mui/material/Tab';
import OrderBehavior from './Charts/Operations/OrderBehavior';
import Returns from './Charts/Operations/Returns';
import ChartTabs from '../Common/ChartTabs';
import { Box } from '@mui/material';
import ProfitOrders from './Charts/Operations/ProfitOrders';
import FrequentItems from './Charts/Operations/FrequentItems';
import Last12MonthOrders from './Charts/Operations/Last12MonthOrders';

export default function Operations(props: { id: number, height: number }) {
  return (
    <Box sx={{ width: '100%', typography: 'body1', height: 'auto', margin: '-25px 0 0 0', padding: 0 }}>
      <ChartTabs tabs={[
        <Tab wrapped style={{ textTransform: 'capitalize' }} label="Order Behavior" value="0" />,
        <Tab wrapped style={{ textTransform: 'capitalize' }} label="Returns" value="1" />,
        <Tab wrapped style={{ textTransform: 'capitalize' }} label="Low Profit Orders" value="2" />,
        <Tab wrapped style={{ textTransform: 'capitalize' }} label="Frequently Purchased Items" value="3" />,
        <Tab wrapped style={{ textTransform: 'capitalize' }} label="Last 12 Month Orders" value="4" />,
      ]} values={["0", "1", "2", "3", "4"]} ariaLabel="Customer operations tabs" panels={[
        <OrderBehavior title="Order Behavior" id={props.id} height={props.height} />,
        <Returns title="Returns" id={props.id} height={props.height} />,
        <ProfitOrders title="Low Profit Orders" id={props.id} height={props.height} />,
        <FrequentItems title="Frequently Purchased Items" id={props.id} height={props.height} />,
        <Last12MonthOrders title="Last 12 Month Orders" id={props.id} height={props.height} />,
      ]} />
    </Box>
  );
}
